import type { ReactElement } from "react";
import { useCallback, useState } from "react";
import Loading from "~/components/common/parts/loading/Loading";

type ReturnType = {
	hideLoader(): void;
	Loader(): ReactElement;
	showLoader(): void;
};

const useLoader = (loading = false): ReturnType => {
	const [isLoading, setIsLoading] = useState<boolean>(loading);
	const showLoader = useCallback((): void => {
		setIsLoading(true);
	}, []);
	const hideLoader = useCallback((): void => {
		setIsLoading(false);
	}, []);
	function Loader(): ReactElement {
		return <Loading isLoading={isLoading} />;
	}

	return { hideLoader, Loader, showLoader };
};

export default useLoader;
